module.exports = __webpack_public_path__ + "img/certyfikat-psychoterapia-uzaleznienia-michal-paczka.0781c04d.jpg";